var exports = {
  "kL": "xfd349460--121693--container",
  "O5": "xfd349460--121693--offers",
  "MJ": "xfd349460--121693--relevance",
};

module.exports = exports;
